<template>
  <path :d="d" class="border" />
</template>

<script>
export default {
  name: 'CountryBorder',
  props: {
    d: { required: true, type: String }
  }
};
</script>

<style lang="scss" scoped>
.border {
  stroke: #0f2133;
  stroke-width: .5px;
  fill: #0f2133;
}
</style>
